import React, { SVGProps } from "react";

export default function SupStar2(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12 5.69353L13.4108 10.2591L13.5197 10.6115H13.8885H18.5219L14.7522 13.4912L14.475 13.7029L14.578 14.0362L16.0047 18.653L12.3035 15.8256L12 15.5937L11.6965 15.8256L7.99529 18.653L9.42198 14.0362L9.52495 13.7029L9.2478 13.4912L5.47815 10.6115H10.1115H10.4803L10.5892 10.2591L12 5.69353Z"
        stroke="currentColor"
      />
    </svg>
  );
}
